/* GoldenLove — sticky add to cart.

   Appears once the real add-to-cart button has scrolled out of view, so the
   buy action is always one tap away. This is the single highest-leverage
   conversion change on a product page, especially on mobile.

   It deliberately does NOT reimplement adding to cart. The button proxies a
   click to Dawn's own add-to-cart button, so variant selection, sold-out
   state, quantity rules, validation and the cart drawer all behave exactly as
   they already do. Duplicating that logic is how a bar like this ends up
   adding the wrong variant.

   It mirrors the real button's state on a MutationObserver, so "Sold out" and
   the disabled state stay in sync when the shopper switches size.
*/

(function () {
  'use strict';

  function init() {
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    var realBtn = form && form.querySelector('button[name="add"]');
    var info = document.querySelector('.product__info-container');
    if (!form || !realBtn || !info) return;
    if (document.querySelector('.voffen-satc')) return;

    var titleEl = document.querySelector('.product__title h1, .product__title');
    var priceEl = document.querySelector('.price__regular .price-item--regular, .price .price-item');
    var imgEl = document.querySelector('.product__media img');

    var bar = document.createElement('div');
    bar.className = 'voffen-satc';
    bar.innerHTML =
      '<div class="voffen-satc__inner">' +
      (imgEl ? '<img class="voffen-satc__thumb" alt="" src="' + imgEl.currentSrc + '">' : '') +
      '<span class="voffen-satc__text">' +
      '<span class="voffen-satc__title"></span>' +
      '<span class="voffen-satc__price"></span>' +
      '</span>' +
      '<button type="button" class="voffen-btn voffen-btn--filled voffen-satc__btn"></button>' +
      '</div>';

    document.body.appendChild(bar);

    var barBtn = bar.querySelector('.voffen-satc__btn');
    bar.querySelector('.voffen-satc__title').textContent = titleEl
      ? titleEl.textContent.trim()
      : '';

    function syncPrice() {
      var p = document.querySelector('.price__regular .price-item--regular, .price .price-item');
      bar.querySelector('.voffen-satc__price').textContent = p ? p.textContent.trim() : '';
    }

    function syncButton() {
      var label = realBtn.querySelector('span');
      barBtn.textContent = (label ? label.textContent : realBtn.textContent).trim();
      barBtn.disabled = realBtn.disabled;
      syncPrice();
    }

    syncButton();

    // Dawn re-renders the form section on variant change, which replaces the
    // button node. Watch the container, then re-resolve the button each time.
    var mo = new MutationObserver(function () {
      var current = document.querySelector('product-form form[action*="/cart/add"] button[name="add"]');
      if (current) realBtn = current;
      syncButton();
    });
    mo.observe(info, { childList: true, subtree: true, attributes: true });

    barBtn.addEventListener('click', function () {
      var current = document.querySelector('product-form form[action*="/cart/add"] button[name="add"]');
      if (current && !current.disabled) current.click();
    });

    // Show the bar once the real button has scrolled above the viewport.
    //
    // A plain scroll check rather than an IntersectionObserver: the observer
    // proved unreliable in testing and failed silently, and a sticky bar that
    // never appears is worse than no sticky bar. This is a rect read behind a
    // rAF gate — cheap, and it cannot quietly not fire.
    var ticking = false;

    function update() {
      ticking = false;
      var current =
        document.querySelector('product-form form[action*="/cart/add"] button[name="add"]') ||
        realBtn;
      var box = current.getBoundingClientRect();

      // Shown whenever the real button is above the viewport. Nothing else.
      //
      // Earlier versions also hid the bar near the footer, which read well in
      // principle and failed in practice: these product pages are short enough
      // that the footer is already on screen by the time the button scrolls
      // off, so the bar never appeared at all. A 66px bar over the footer is a
      // far smaller cost than a buy button that is never reachable.
      bar.classList.toggle('is-shown', box.bottom < 0);
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
